'use strict';

import Singleton from './singleton';

module.exports = new Singleton();



/** WEBPACK FOOTER **
 ** ./src/default_tracer.js
 **/